import React from 'react';

import { SvgComponent } from '@/types/modules/svg.types';

export const Options: SvgComponent = (props) => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="1" y="3" width="14" height="2" rx="1" fill="currentColor" />
		<rect x="1" y="7" width="14" height="2" rx="1" fill="currentColor" />
		<rect x="1" y="11" width="14" height="2" rx="1" fill="currentColor" />
	</svg>
);
